import React from "react";
import { DatePicker, Form, FormInstance, Input, Select, TimePicker } from "antd";
import dayjs from "../../../../utils/formacion/dayjs-timezone";
import {
  DEFAULT_TIMEZONE,
  DURATION_OPTIONS,
  TIMEZONE_OPTIONS,
} from "../../../../utils/formacion/training-display";
import CoverUploadInput from "./CoverUploadInput";
import styles from "./styles.module.scss";

interface Props {
  form: FormInstance;
  schoolId: number | null;
  trainingId?: number;
  onJoinUrlChange?: (joinUrl: string) => void;
}

const DetailsTab: React.FC<Props> = ({
  form,
  schoolId,
  trainingId,
  onJoinUrlChange,
}) => (
  <div>
    <Form.Item
      label="Título"
      name="title"
      rules={[{ required: true, message: "Debes agregar un título" }]}
    >
      <Input size="large" placeholder="Título de la capacitación" />
    </Form.Item>

    <div className={styles.fieldRow}>
      <Form.Item
        label="Fecha"
        name="startDate"
        rules={[{ required: true, message: "Debes agregar una fecha" }]}
      >
        <DatePicker size="large" style={{ width: "100%" }} format="D/M/YYYY" />
      </Form.Item>
      <Form.Item
        label="Hora"
        name="startTime"
        rules={[{ required: true, message: "Debes agregar una hora" }]}
      >
        <TimePicker
          size="large"
          style={{ width: "100%" }}
          format="h:mm a"
          needConfirm={false}
          defaultOpenValue={dayjs().hour(0).minute(0).second(0)}
        />
      </Form.Item>
      <Form.Item
        label="Duración"
        name="duration_min"
        rules={[{ required: true, message: "Debes seleccionar una duración" }]}
      >
        <Select size="large" options={DURATION_OPTIONS} />
      </Form.Item>
    </div>

    <Form.Item
      label="Enlace de inscripción (Zoom)"
      name="registration_url"
      rules={[
        { required: true, message: "Debes agregar un enlace de inscripción" },
        { type: "url", message: "Ingresa un enlace válido" },
      ]}
    >
      <Input size="large" placeholder="https://zoom.us/..." />
    </Form.Item>

    <Form.Item
      label="Enlace para entrar al webinar"
      name="join_url"
      rules={[
        {
          required: true,
          message: "Debes agregar un enlace para entrar al webinar",
        },
        { type: "url", message: "Ingresa un enlace válido" },
      ]}
    >
      <Input
        size="large"
        placeholder="https://zoom.us/..."
        onChange={(e) => onJoinUrlChange?.(e.target.value)}
      />
    </Form.Item>

    <Form.Item
      label="ID del webinar (Zoom)"
      name="zoom_webinar_id"
      rules={[
        {
          pattern: /^\d{9,11}$/,
          message: "El ID del webinar tiene entre 9 y 11 dígitos",
        },
      ]}
      extra="Se completa solo al pegar el enlace del webinar. Podés corregirlo."
    >
      <Input size="large" inputMode="numeric" placeholder="86123456789" />
    </Form.Item>

    <Form.Item
      label="Zona horaria"
      name="timezone"
      initialValue={DEFAULT_TIMEZONE}
    >
      <Select size="large" options={TIMEZONE_OPTIONS} />
    </Form.Item>

    {trainingId && (
      <Form.Item label="Portada" name="cover_image_url">
        <CoverUploadInput schoolId={schoolId} trainingId={trainingId} />
      </Form.Item>
    )}
  </div>
);

export default DetailsTab;
